export default __webpack_public_path__ + "static/media/bg.10777660.png";